module.exports = __webpack_public_path__ + "static/Nowsta-32ae112d7d2ab92b69079a50a39563e3.jpg";